export default __webpack_public_path__ + "images/7a12ba7bb8b301572e20f84e0ddd5962-top40_music_small.webp";